"use strict";
exports.__esModule = true;
exports.GdcDashboardPlugin = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * @public
 */
var GdcDashboardPlugin;
(function (GdcDashboardPlugin) {
    function isDashboardPlugin(obj) {
        return !isEmpty_1["default"](obj) && obj.dashboardPlugin !== undefined;
    }
    GdcDashboardPlugin.isDashboardPlugin = isDashboardPlugin;
})(GdcDashboardPlugin = exports.GdcDashboardPlugin || (exports.GdcDashboardPlugin = {}));
//# sourceMappingURL=GdcDashboardPlugin.js.map